$(document).ready(function()
{

    var $protectedButtons = $('.protected-downloads-button');
    var $protectedAreas = $('.protected-container, .protected-downloads, .protected-downloads-button, .protected-section');
    var $protectedGates = $('.protected-downloads-gate');
    var $protectedDownloadsModal = $('#protectedDownloadsModal');
    var clicked_element_from_top = 0;

    var cookieName = 'downloadsEmail'; // this should match up with PHP DownloadLogger class

    function setCookie(name,value,days) {
        let expires = "";
        if (days && days > 0) {
            let date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookieByName(name) 
    {
        var pair = document.cookie.match(new RegExp(name + '=([^;]+)'));
        return !!pair ? pair[1] : null;
    }


    function getAbsolutePosition(element) 
    {

        var offset = element.offset();
        if (offset)
        {
            return offset.top;
        }

        return 0;

    }

    function stripProtectedButtons()
    {
       
        $protectedButtons.removeData('bs-toggle');
        $protectedButtons.removeData('bs-target');
        $protectedButtons.removeAttr('data-bs-toggle');
        $protectedButtons.removeAttr('data-bs-target');
        $protectedButtons.removeClass('active');

        /*setTimeout( function()
        { 
            $protectedButtons.removeClass('protected-downloads-button);
        }, 250);*/

    }

    jQuery(document).bind('gform_confirmation_loaded', function(event, formId)
    {

        $protectedAreas.removeClass("active");
        $protectedGates.removeClass("active");
        $protectedDownloadsModal.modal('hide');
        stripProtectedButtons();

        if (clicked_element_from_top && clicked_element_from_top > 0)
        {
            $('html, body').animate({
                scrollTop: ( clicked_element_from_top - 300 )
            },500);       
        }
        else
        {
            $('html, body').animate({
                scrollTop: (( $protectedAreas.first().offset().top) - 300)
            },500);
        }
    });

    // on submit set a cookie for tracking purposes
    $('#protectedDownloadsModal form').submit(function( e )
    {

        //console.log(e);
        //console.log($(this));
        
        var cluster = $(this).find(".user_email");

        if (cluster.length)
        {
            cluster.each(function()
            {
                var email = $(this).find("input").val();
                if (email && email.length)
                {
                    setCookie(cookieName, email, 0);
                }
            });
        }
    });

    $protectedButtons.click(function(e)
    {
        clicked_element_from_top = getAbsolutePosition( $(this) ) ; 
        //console.log( 'return to: ' + clicked_element_from_top );
        // rest is handled by BS modal
    });

    //console.log(getCookieByName(cookieName));


    // on load, if session cookie is set, we don't need any ot this
    if (getCookieByName(cookieName))
    {
        $protectedAreas.removeClass("active");
        $protectedGates.removeClass("active");
        $protectedDownloadsModal.modal('hide');
        stripProtectedButtons();
    }

});